import ProductIdentifier from '@ingka/product-identifier';
import Table, { TableBody, TableHeader } from '@ingka/table';
import Text from '@ingka/text';
import { translate } from '@repo/phrase';

import { ArticleTitleDescription } from '@/components/article-title-description/article-title-description.component';

import type { FulfillmentArticle } from '../fulfillment.types';

import styles from './styles.module.scss';

interface FulfillmentArticlesProps {
    readonly articles: readonly FulfillmentArticle[];
}

export const FulfillmentArticles = ({ articles }: FulfillmentArticlesProps) => {
    if (articles.length === 0) {
        return null;
    }

    return (
        <div className={String(styles.articles_wrapper)}>
            <Table fullWidth className={String(styles.articles)}>
                <TableHeader>
                    <tr>
                        <th className={String(styles.quantity_cell)} scope="col">
                            <Text tagName="span" textStyle="Body.M">
                                {translate('summary_modal_article_table_quantity')}
                            </Text>
                        </th>
                        <th scope="col">
                            <Text tagName="span" textStyle="Body.M">
                                {translate('summary_modal_article_table_article')}
                            </Text>
                        </th>
                        <th className={String(styles.article_number_cell)} scope="col">
                            <Text tagName="span" textStyle="Body.M">
                                {translate('summary_modal_article_table_article_number')}
                            </Text>
                        </th>
                    </tr>
                </TableHeader>
                <TableBody>
                    {articles.map((article) => (
                        <tr key={article.id}>
                            <td className={String(styles.quantity_cell)}>
                                <Text tagName="span" textStyle="Body.M">
                                    {article.quantity}
                                </Text>
                            </td>
                            <td>
                                <ArticleTitleDescription
                                    title={article.name}
                                    description={article.description}
                                    isReferenceItem={article.isReferenceItem}
                                />
                            </td>
                            <td className={String(styles.article_number_cell)}>
                                <ProductIdentifier subtle value={article.articleNumber ?? ''} />
                            </td>
                        </tr>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};
